import { Button } from 'antd';
import styled from 'styled-components';

interface StyledDateProps {
  selected: boolean;
}

export const StyledDatePickerWrapper = styled.div``;

export const StyledDate = styled.div<StyledDateProps>`
  border-radius: 6px;
  cursor: pointer;
  padding: 2px 0;
  transition: all 0.2s;
  text-align: center;
  background-color: ${({ selected }) => (selected ? '#ff1818ff' : '#fff')};
  :hover {
    background-color: #e6f7ff;
  }
`;

export const StyledButtonsBlock = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
